import React, { useState } from 'react';
import { Tooltip, CircularProgress } from '@mui/material';
import { CiExport } from 'react-icons/ci';

const ExportButton = ({ exportToExcel }) => {
  
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      await exportToExcel();
    } catch (error) {
      console.error('Export failed:', error);
    }
    setLoading(false);
  };

  return (
    <Tooltip title="Export to Excel">
      <button
        onClick={handleExport}
        style={{ border: 'none', background: 'transparent', cursor: loading ? 'not-allowed' : 'pointer' }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : <CiExport size={24} />}
      </button>
    </Tooltip>
  );
};

export default ExportButton;
